/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Flex, FormControl, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaCopy, FaRegPlayCircle, FaStopCircle, FaTrash, FaExclamationTriangle } from 'react-icons/fa'
import { iPutQuestaoFlexivel, iQuestaoFlexivel } from '../../../../../../interfaces'
import { Container } from './styles'
import { AiFillCaretUp, AiFillCaretDown } from 'react-icons/ai'
import { ElementoTooltipCmp } from '../../../../../../components/ElementoTooltipCmp'
import { SelectCmp } from '../../../../../../components/SelectCmp'
import { InputCmp } from '../../../../../../components/InputCmp'
import { SwitchCmp } from '../../../../../../components/SwitchCmp'
import { CheckboxCmp } from '../../../../../../components/CheckboxCmp'

interface iQuestaoProps{
  questao: iQuestaoFlexivel
  isInvalid: boolean
  onDelete: (id: string) => void
  onDesabilitar: (id: string) => void
  onDuplicar: (id: string) => void
  onUpdate: (questao: iPutQuestaoFlexivel, id: string) => void
  onAcima: () => void
  onAbaixo: () => void
  verificaSetas: () => string
  isFeedback?: boolean
  isModeloPadrao: boolean
  ciclicaIniciada?: boolean
  invalidEnunciado?: boolean
}

export const Questao: React.FC<iQuestaoProps> = ({ questao, children, onDelete, onUpdate, onDuplicar, onAcima, onAbaixo, verificaSetas, isInvalid, isFeedback, isModeloPadrao, ciclicaIniciada, onDesabilitar, invalidEnunciado }) => {
  const [GestorRespondente, setGestorRespondente] = useState<boolean | undefined>()
  const [ColaboradorRespondente, setColaboradorRespondente] = useState<boolean | undefined>()
  const [Obrigatoria, setObrigatoria] = useState(false)
  const [Tipo, setTipo] = useState('0')
  const [Enunciado, setEnunciado] = useState('')

  useEffect(() => {
    setColaboradorRespondente((questao.colaboradorRespondente === undefined || questao.colaboradorRespondente === null) ? isFeedback : questao.colaboradorRespondente)
    setGestorRespondente((questao.gestorRespondente === undefined || questao.gestorRespondente === null) ? false : questao.gestorRespondente)
    setObrigatoria(questao.obrigatoria)
    setEnunciado(questao.enunciado)
    setTipo(questao.tipo.toString())
  }, [])

  function AbstracatUpdate(tipo?: string): void {
    onUpdate({
      enunciado: Enunciado,
      obrigatoria: Obrigatoria,
      tipo: tipo !== undefined ? parseInt(tipo) : parseInt(Tipo),
      colaboradorRespondente: ColaboradorRespondente,
      gestorRespondente: GestorRespondente
    }, questao.id)
  }

  return (
          <Container style={{ position: 'relative', border: (isInvalid && (questao.tipo === 0 || questao.tipo === 5) && (questao.alternativas.length === 0 || questao.alternativas.some(a => a.texto === ''))) ? '1px solid var(--Red)' : '' }}>
            {!isModeloPadrao && <Box as='span' position={'absolute'} right={'.5rem'} top={'.5rem'} display={'flex'} justifyContent={'center'} alignItems={'start'} gap={'2rem'}>
              {ciclicaIniciada === false && questao.proximoCiclo && <Text fontSize={'14px'}>Questão editável até dia <strong>{questao.proximoCiclo}</strong></Text>}
              {questao.podeReativar === true && <Text fontSize={'14px'}>Questão pode ser reativada até dia <strong>{questao.proximoCiclo}</strong></Text>}
              <Flex flexDirection={'column'}>
                <ElementoTooltipCmp bg={'var(--Azul)'} label='Mover a questão uma posição acima'>
                  <Box h={'16px'} _hover={{ color: 'var(--Azul)', cursor: 'pointer' }} onClick={onAcima}>
                    {(verificaSetas() !== '0') && (verificaSetas() !== '3') && (<AiFillCaretUp/>)}
                  </Box>
                </ElementoTooltipCmp>
                <ElementoTooltipCmp bg={'var(--Azul)'} label='Mover a questão uma posição abaixo'>
                  <Box h={'16px'} _hover={{ color: 'var(--Azul)', cursor: 'pointer' }} onClick={onAbaixo}>
                    {(verificaSetas() !== '1') && (verificaSetas() !== '3') && (<AiFillCaretDown/>)}
                  </Box>
                </ElementoTooltipCmp>
              </Flex>
            </Box>}
            <Flex gap={'.75rem'}>
                <FormControl width={'35%'}>
                    <SelectCmp isDisabled={isModeloPadrao || ciclicaIniciada} title='Formato da pergunta' OnChange={(e) => {
                      setTipo(e)
                      AbstracatUpdate(e)
                    }} value={Tipo}>
                        <option value={'0'}>Múltipla escolha</option>
                        <option value={'5'}>Caixa de seleção</option>
                        <option value={'1'}>Discursiva</option>
                        <option value={'6'}>Escala</option>
                        <option value={'4'}>eNPS</option>
                    </SelectCmp>
                </FormControl>

                  <FormControl width={'65%'}>
                  <Box position="relative" id={`questao-${questao.id}`}>
                    <InputCmp
                      label='Pergunta'
                      onBlur={() => AbstracatUpdate()}
                      OnChange={setEnunciado}
                      value={Enunciado}
                      isInvalid={!!invalidEnunciado}
                      isDisabled={ciclicaIniciada}
                      placeholder={'Escreva a pergunta'}
                    />

                    {!!invalidEnunciado && (
                      <Box
                        position="absolute"
                        right="-8px"
                        top="-10px"
                        bg="#F6E05E"
                        color="#744210"
                        px="10px"
                        py="6px"
                        borderRadius="8px"
                        display="flex"
                        alignItems="center"
                        gap="6px"
                        boxShadow="md"
                        fontSize="12px"
                        fontWeight="600"
                        zIndex={10}
                        pointerEvents="none"
                      >
                        <FaExclamationTriangle size={12} />
                        Campo obrigatório
                      </Box>
                    )}
                  </Box>
                </FormControl>

            </Flex>
            <Flex margin={'1rem 0rem'}>
                {children}
            </Flex>

            {!isModeloPadrao && <Flex justifyContent={'end'}>
                {isFeedback && <FormControl width={'fit-content'} display='flex' alignItems='center' gap={'1rem'} mr={'1rem'}>
                    <CheckboxCmp onBlur={() => AbstracatUpdate()} OnChange={setGestorRespondente} isChecked={GestorRespondente}>
                      Gestor poderá responder esta questão
                    </CheckboxCmp>
                    <CheckboxCmp onBlur={() => AbstracatUpdate()} OnChange={setColaboradorRespondente} isChecked={ColaboradorRespondente}>
                      Subordinado poderá responder esta questão
                    </CheckboxCmp>
                </FormControl>}
                {!ciclicaIniciada && <FormControl width={'fit-content'} display='flex' alignItems='center'>
                  <SwitchCmp onBlur={() => AbstracatUpdate()} OnChange={setObrigatoria} value={Obrigatoria} id='email-alerts' legendaDireita='Obrigatória'/>
                </FormControl>}
                <Flex marginLeft={'1.5rem'} gap={'0rem .75rem'}>
                  <ElementoTooltipCmp bg={'var(--Azul)'} label={'Duplicar questão'}>
                    <FaCopy onClick={() => onDuplicar(questao.id)} cursor={'pointer'} color='var(--Azul)' size={20} />
                  </ElementoTooltipCmp>
                  {!ciclicaIniciada && <ElementoTooltipCmp bg={'var(--Red)'} label={'Excluir questão'}>
                    <FaTrash cursor={'pointer'} onClick={() => onDelete(questao.id)} color='var(--Red)' size={20} />
                  </ElementoTooltipCmp>}
                  {ciclicaIniciada && !questao.desabilitada && <ElementoTooltipCmp bg={'var(--Red)'} label={'Desabilitar questão nos próximos ciclos'}>
                    <FaStopCircle cursor={'pointer'} onClick={() => onDesabilitar(questao.id)} color='var(--Red)' size={20} />
                  </ElementoTooltipCmp>}

                  {questao.podeReativar && questao.desabilitada && <ElementoTooltipCmp bg={'var(--Green2)'} label={'Reativar questão'}>
                    <FaRegPlayCircle cursor={'pointer'} onClick={() => onDesabilitar(questao.id)} color='var(--Green2)' size={20} />
                  </ElementoTooltipCmp>}
                </Flex>
            </Flex>}
        </Container>
  )
}
